// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';

export enum ProfileRouteNames {
  UserProfilePage = 'UserProfile',
  PersonalInformationTab = 'PersonalInformationTab',
}

const profileRoutes = [
  {
    path: '/clientdashboard/user-profile',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: ProfileRouteNames.UserProfilePage,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/components/UserProfile.vue'),
        meta: {
          useLayouts: true,
          withoutDashboardAccess: true,
        },
        beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
          await store.dispatch('user/get');
          next();
        },
        children: [
          {
            path: 'personal-information',
            name: ProfileRouteNames.PersonalInformationTab,
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            component: () => import('@client/pages/userProfile/PersonalInformation.vue'),
            meta: {
              withoutDashboardAccess: true,
              useLayouts: true,
            },
          },
        ],
      },
    ],
  },
];

export default profileRoutes;
